import { CurrencyInput } from '@new-components/elements';

import ApplicationCard from '../../../../../application-card';

import { ExpenseIncomeProps } from './types';

const ExpenseIncome = (props: ExpenseIncomeProps) => {
  const { readonly } = props;

  return (
    <ApplicationCard>
      <CurrencyInput
        disabled={readonly}
        isAllowOnlyZero
        name='monthlyIncome'
        label='Total Penghasilan per Bulan'
        helperText='Masukan total penghasilan dari Grab dan di luar Grab'
      />
    </ApplicationCard>
  );
};

export default ExpenseIncome;
